export enum UserType {
  Supplier = "Supplier",
  Admin = "Admin",
  Client = "Client",
  JobSeeker = "Jobseeker"
  }